import { Component, ChangeDetectionStrategy, inject, input, output, model } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { IconComponent, cueClose } from '@cue/ui/icons';
import { NgClass } from '@angular/common';

@Component({
  selector: 'cue-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass],
})
export class ModalHeaderComponent {
  public modal = inject(ModalComponent);
  title = input('');
  emitClose = input(false);
  tabs = input<string[]>();
  tabsVisible = input(false);
  tabClick = output<number>();
  headerClose = output<void>();

  selectedTab = model(0);
  cueClose = cueClose;

  xClose() {
    if (this.emitClose()) {
      this.headerClose.emit();
    } else {
      this.modal.onClose();
    }
  }
  changeTab(i: number) {
    this.selectedTab.set(i);
    this.tabClick.emit(i);
  }
}
